const moodGifContext = require.context('../gifs', false, /\.gif$/i);
const helloGifContext = require.context('../hello gifs', false, /\.gif$/i);

function mapContextToGifs(ctx, idPrefix) {
  return ctx.keys().map((key) => {
    const filename = key.replace('./', '');
    const title = filename.replace(/\.gif$/i, '');
    const url = ctx(key);
    return { id: `${idPrefix}-${filename}`, gifUrl: url, fullUrl: url, title };
  });
}

/** Bundled mood/spirit GIFs (`src/gifs`), same pool as InlineSurvey local grid. */
export const MOOD_LOCAL_GIFS = mapContextToGifs(moodGifContext, 'mood-local');

/** Bundled hello GIFs (`src/hello gifs`), same pool as reach-out local grid. */
export const HELLO_LOCAL_GIFS = mapContextToGifs(helloGifContext, 'hello-local');

function shuffleSlice(source, count) {
  const shuffled = [...source].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
}

/** Random subset from hello folder only (e.g. feed reach-out picker). */
export function getRandomHelloGifsInitial(count = 9) {
  return shuffleSlice(HELLO_LOCAL_GIFS, count);
}

/** Full hello bundle shuffled — reach-out modal: all locals before KLIPY. */
export function getShuffledHelloGifsAll() {
  return shuffleSlice(HELLO_LOCAL_GIFS, HELLO_LOCAL_GIFS.length);
}

/** Random subset from mood/spirit folder only — same pool as InlineSurvey spirit_gif initial grid. */
export function getRandomMoodLocalGifs(count = 9) {
  return shuffleSlice(MOOD_LOCAL_GIFS, count);
}

/** Random subset from mood + hello folders combined (e.g. messaging GIF picker). */
export function getRandomMoodAndHelloGifs(count = 9) {
  const combined = [...MOOD_LOCAL_GIFS, ...HELLO_LOCAL_GIFS];
  return shuffleSlice(combined, count);
}

/** Full mood + hello pool shuffled — messaging picker shows every local GIF first, then KLIPY. */
export function getShuffledMoodAndHelloGifsAll() {
  const combined = [...MOOD_LOCAL_GIFS, ...HELLO_LOCAL_GIFS];
  return shuffleSlice(combined, combined.length);
}
